import React from 'react';
import { shotSrcSet } from './shots';
import { Highlight, Kicker, Paragraphs, assetUrl } from './ui';

/*
 * Figma "banner" (node 35713:376): full-width #243644 band, 1060px tall at 1800.
 * The 1520px screenshot is cut off by the bottom edge (551 of 661px visible).
 */
const RadarSection = ({ radar }) => (
  <section
    id="prijsradar"
    className="mt-[clamp(40px,5.3333vw,96px)] overflow-hidden bg-brand-night text-white"
    data-testid="radar-section"
  >
    <div className="hp-container pt-[clamp(56px,5.3889vw,97px)] text-center">
      <Kicker>{radar.kicker}</Kicker>
      <h2 className="hp-h2-bold mx-auto mt-[clamp(18px,1.3333vw,24px)] max-w-[13.99em]">
        <Highlight text={radar.title} accent="text-brand" />
      </h2>
      <div className="mx-auto mt-[clamp(18px,1.7778vw,32px)] max-w-[38.5em] text-[clamp(16px,1.3333vw,24px)] font-medium leading-[1.5833]">
        <Paragraphs text={radar.body} />
      </div>
      <div
        className="relative mx-auto mt-[clamp(32px,3.3333vw,60px)] aspect-[1520/551] w-full max-w-[1520px] overflow-hidden rounded-t-[clamp(10px,1.1111vw,20px)] bg-white"
        data-testid="radar-app-shot"
      >
        <img src={assetUrl(radar.image_url)} srcSet={shotSrcSet(radar.image_url)} sizes="(min-width: 1520px) 1520px, 100vw" alt={radar.kicker} loading="lazy" decoding="async" className="absolute left-0 top-0 h-auto w-full" />
      </div>
    </div>
  </section>
);

export default RadarSection;
